// Hosts we will redirect to after a 402 response. MultiSafepay is the only provider configured
// across all propositions (see `proposition.billing.paymentProvider` in libs/proposition/src/configs).
// Known hosts: `testpayv2.multisafepay.com` (acceptance), `pay.multisafepay.com` (production).
const ALLOWED_PAYMENT_HOST_SUFFIXES = ['.multisafepay.com'];

export const isValidPaymentUrl = (value: unknown): value is string => {
  if (typeof value !== 'string' || value.length === 0) {
    return false;
  }

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }

  if (url.protocol !== 'https:') {
    return false;
  }

  return ALLOWED_PAYMENT_HOST_SUFFIXES.some((suffix) => url.hostname.endsWith(suffix));
};
